import {
  MODULES_FOR_PARTNER_SUCCESS,
  MODULES_FOR_PARTNER_FAILED,
  RESET_MODULES_FOR_PARTNER,
  LOADING_MODULES_FOR_PARTNER,
  NETWORK_ERROR_MODULES_FOR_PARTNER,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetModulesForPartner = () => {
  return { type: RESET_MODULES_FOR_PARTNER };
};

const getModulesForPartner = (userData, authTokenIs, history) => async (dispatch) => {
  dispatch({ type: LOADING_MODULES_FOR_PARTNER });
  await partnerServices
    .post("modulesForPartner", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(modulesForPartnersuccess(res.data));
          history.push({ pathname: "/index/homepage" });
          break;
        default:
          dispatch(modulesForPartnerFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_MODULES_FOR_PARTNER, payload: err });
    });
};
function modulesForPartnersuccess(data) {
  return {
    type: MODULES_FOR_PARTNER_SUCCESS,
    payload: data,
  };
}
function modulesForPartnerFailed(data) {
  return {
    type: MODULES_FOR_PARTNER_FAILED,
    payload: data,
  };
}

export { resetModulesForPartner, getModulesForPartner };
